import React, { useState } from 'react';
import { Button, Input, Tooltip } from 'antd';
import { ArrowRightOutlined, XFilled } from '@ant-design/icons';
import { ASSIST_ACTIONS, isAssistOpLoading } from './promptAssistActions';
import './PromptEditor.css';

export default function PromptAssistPanel({
  assistOp,
  onAction,
  onAskSubmit,
  onStop,
  variant = 'footer',
  onMouseDown,
}) {
  const [askValue, setAskValue] = useState('');

  const isFreeformLoading = assistOp === 'freeform';
  const loading = assistOp != null;

  const handleAskSubmit = () => {
    if (!askValue.trim() || isFreeformLoading) return;
    onAskSubmit(askValue.trim());
  };

  const handleAskKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      e.stopPropagation();
      if (!isFreeformLoading) handleAskSubmit();
    }
  };

  const suffixControl = (
    <span className="prompt-assist-ask-suffix">
      {isFreeformLoading ? (
        <button
          type="button"
          className="prompt-assist-ask-stop-btn"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            onStop?.();
          }}
          aria-label="Stop"
        >
          <span className="prompt-assist-ask-stop-ring" aria-hidden />
          <XFilled className="prompt-assist-ask-stop-icon" />
        </button>
      ) : (
        <Button
          type="text"
          size="small"
          className="prompt-assist-ask-run"
          icon={<ArrowRightOutlined />}
          disabled={!askValue.trim() || loading}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            handleAskSubmit();
          }}
          aria-label="Run"
        />
      )}
    </span>
  );

  return (
    <div
      className={`prompt-assist-panel prompt-assist-panel--${variant}`}
      onMouseDown={onMouseDown}
      role="dialog"
      aria-label="AI assist"
    >
      <div className="prompt-assist-panel-actions">
        {ASSIST_ACTIONS.map(({ key, icon: Icon, label }) => (
          <Tooltip key={key} title={label} placement="top">
            <Button
              type="text"
              size="small"
              className="prompt-assist-toolbar-btn"
              icon={<Icon />}
              loading={isAssistOpLoading(assistOp, key)}
              disabled={loading && !isAssistOpLoading(assistOp, key)}
              onMouseDown={(e) => e.preventDefault()}
              onClick={() => onAction(key)}
              aria-label={label}
            />
          </Tooltip>
        ))}
      </div>

      <div className="prompt-assist-ask" onKeyDown={(e) => e.stopPropagation()}>
        <Input
          value={askValue}
          onChange={(e) => setAskValue(e.target.value)}
          placeholder="Ask AI to change something…"
          onKeyDown={handleAskKeyDown}
          className="prompt-assist-ask-input"
          suffix={suffixControl}
          disabled={isFreeformLoading}
        />
      </div>
    </div>
  );
}
